import { NgModule } from '@angular/core';
import { BpButtonGroupComponent } from './button-group.component';
import { BpButtonToolbarComponent } from './button-toolbar.component';

@NgModule({
  declarations: [
    BpButtonGroupComponent,
    BpButtonToolbarComponent
  ],
  exports: [
    BpButtonGroupComponent,
    BpButtonToolbarComponent
  ]
})
export class BpButtonGroupModule { }
